<div class="ca-form-field-container" [class.error]="hasError">
  <ng-content></ng-content>
  <div *ngIf="error" class="errors">
    {{ "validation." + error | translate }}
  </div>
</div>
